export default __webpack_public_path__ + "static/media/icon_chevron-down.ce9c5674.svg";